<template>
  <div style="margin:20px 0">
    <Table
      border
      :loading="loading"
      :columns="columns"
      :span-method="handleSpan"
      :data="data"
      ref="table"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      v-show="false"
      :columns="columnsA"
      :data="exportDataList"
      :span-method="handleSpan"
      ref="tableRef"
    ></Table>
    <div
      style="margin:20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <Button type="primary" style="margin-top:15px" @click="exportData()"
        ><!-- 导出 -->{{ $t("PB_Export") }}</Button
      >
    </div>
  </div>
</template>

<script>
import DateUtil from "../../../../../util/DateUtil";
import axios from "axios";
export default {
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      data: [],
      spanb: [],
      spanc: [],
      searchItem: {},
      exportDataList: []
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 80,
          fixed: "left"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 80
        },
        {
          title: this.$t("Performance_Priorities") /* 绩效重点 */,
          key: "achKeyNote",
          align: "center",
          minWidth: 330
        },
        {
          title: this.$t("Weight") /* 权重 */,
          key: "weight",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Detailed_Description") /* 详细描述 */,
          key: "details",
          align: "center",
          minWidth: 350
        },
        {
          title: this.$t("Start_Date") /* 开始日期 */,
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("End_Date") /* 结束日期 */,
          key: "endDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Detailed_Measures") /* 衡量指标 */,
          key: "measure",
          align: "center",
          minWidth: 200
        },
        // {
        //     title: this.$t('Completion_Status'),/* 实际完成情况 */
        //     key: "finish",
        //     align: "center",
        //     minWidth:200
        // },
        {
          title: this.$t("Employee_Comment") /* 员工说明 */,
          key: "empDetails",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Dotted-Line_Manager_Appraisal") /* 虚线上级评估 */,
          key: "indirSupFeedback",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          key: "dirSupFeedback",
          align: "center",
          minWidth: 200
        }
      ];
    },
    columnsA() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left"
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Performance_Priorities") /* 绩效重点 */,
          key: "achKeyNote",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Weight") /* 权重 */,
          key: "weight",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Detailed_Description") /* 详细描述 */,
          key: "details",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Start_Date") /* 开始日期 */,
          key: "startDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.startDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("End_Date") /* 结束日期 */,
          key: "endDate",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.endDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Detailed_Measures") /* 衡量指标 */,
          key: "measure",
          align: "center",
          minWidth: 300
        },
        // {
        //     title: this.$t('Completion_Status'),/* 实际完成情况 */
        //     key: "finish",
        //     align: "center",
        //     minWidth:120
        // },
        {
          title: this.$t("Employee_Comment") /* 员工说明 */,
          key: "empDetails",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Dotted-Line_Manager_Appraisal") /* 虚线上级评估 */,
          key: "indirSupFeedback",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线上级反馈 */,
          key: "dirSupFeedback",
          align: "center",
          minWidth: 120
        }
      ];
    }
  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 1 ||
        columnIndex === 0 ||
        columnIndex === 2 ||
        columnIndex === 3 ||
        columnIndex === 4
      ) {
        if (this.spanb[rowIndex]) {
          return {
            rowspan: this.spanb[rowIndex],
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      if (
        column.key === "achKeyNote" ||
        column.key === "weight" ||
        column.key === "details" ||
        column.key === "startDate" ||
        column.key === "endDate" ||
        column.key === "empDetails" ||
        column.key === "dirSupFeedback" ||
        column.key === "indirSupFeedback"
      ) {
        if (this.spanc[rowIndex]) {
          return {
            rowspan: this.spanc[rowIndex],
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 1
          };
        }
      }
    },
    spanbFun(array) {
      let contactDotb = 0;
      let spanb = [];
      array.forEach((item, index) => {
        if (index === 0) {
          spanb.push(1);
        } else {
          if (item.id === array[index - 1].id) {
            spanb[contactDotb] += 1;
            spanb.push(0);
          } else {
            contactDotb = index;
            spanb.push(1);
          }
        }
      });
      this.spanb = spanb;
    },
    tableSpan(array) {
      let contactDotb = 0;
      let spanb = [];
      array.forEach((item, index) => {
        if (index === 0) {
          spanb.push(1);
        } else {
          if (
            item.id == array[index - 1].id &&
            item.commonId == array[index - 1].commonId
          ) {
            spanb[contactDotb] += 1;
            spanb.push(0);
          } else {
            contactDotb = index;
            spanb.push(1);
          }
        }
      });
      this.spanc = spanb;
    },
    pageChange(val) {
      this.$emit("pageChange", val);
    },
    pageSizeChange(val) {
      this.$emit("pageSizeChange", val);
    },
    exportData() {
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 99999
      };
      this.loading = true;
      axios.post("/achReport/selectKeyNoteInfo", obj).then(res => {
        if (res) {
          res.data.forEach(item => {
            item.startDate = this.date.dateVal(item.startDate, "YYYY-MM-DD");
            item.endDate = this.date.dateVal(item.endDate, "YYYY-MM-DD");
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "tableRef",
              `${this.$t("Performance_Priorities")}-${this.$t(
                "End-Year_Review_Over"
              )}` + this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
              res.data
            ); /* 绩效重点-年终总结 */
          });
        }
        this.loading = false;
      });

      // this.$refs.table.exportCsv({
      //     filename: '绩效重点-年终总结'
      // });
    },
    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.id +
        "&serialnumber=" +
        row.serialnumber +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
      // this.$router.push({
      //     path: '/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27',
      //     query: { id: row.id ,serialnumber:row.serialnumber,year:row.year}
      // })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/tableComponents/PerformanceFocusTableC.vue